import handleCaptcha from './ComponentCaptcha.js'

window.addEventListener('load', () => {
  const form = document.querySelector(`[data-form="contact"]`)

  $('[data-form="contact"]').on('beforeSubmit', function (e) {
    e.preventDefault()

    const slug = form.getAttribute('data-training')

    if (slug) {
      const formData = new FormData(form)
      const data = {}
      for (let keyValue of formData.entries()) {
        data[keyValue[0]] = keyValue[1]

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: `register_${slug}`,
          form: data,
        })
      }
    }

    handleCaptcha(form).then(() => {
      form.submit()
    })
    return false
  })
})
